import { List, ListItem } from '@ds/components'

import { AudioCardSkeleton } from '@features/audio-card'

import { type TOtherCreatorsSkeletonProps } from './OtherCreators.types'

import styles from './OtherCreators.module.css'

const DEFAULT_SKELETON_COUNT = 10

export const OtherCreatorsSkeleton = ({
    title,
    count = DEFAULT_SKELETON_COUNT,
}: TOtherCreatorsSkeletonProps) => {
    const rowCount = Math.max(0, Math.trunc(count))

    return (
        <section className={styles.section}>
            <h2 className={styles.title}>{title}</h2>
            <List>
                {[...Array(rowCount).keys()].map(index => (
                    <ListItem key={`other-creators-skeleton-${index}`}>
                        <AudioCardSkeleton />
                    </ListItem>
                ))}
            </List>
        </section>
    )
}
